import React from 'react';

export const NoPage = ({ location }) => (
    <div className="content-wrapper">
    	<section className="content">
    	<h1>404</h1>
    	<h3>
		  No match for <code>{location.pathname}</code>
		</h3>
      </section>
    </div>
);


// WEBPACK FOOTER //
// ./src/pages/NoPage.js